/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-allium/build/rn/icons/ChevronRight'
const theme = {
  appearances: { inverse: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        color: '#ffffff',
        currentColor: '#ffffff',
        iconColor: '#b2b9bf'
      }
    }
  ],
  tokens: {
    color: '#676e73',
    currentColor: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 12,
    fontWeight: '500',
    icon: PaletteIconChevronRight,
    iconColor: '#b2b9bf',
    iconContainerSize: 16,
    iconPadding: 4,
    iconSize: 16,
    lineHeight: 1.33333333333,
    listItemPadding: 0
  }
}
export default theme
